import { Done, DoneAll, Error } from "@mui/icons-material";
import { Box, styled } from "@mui/material";
import React from "react";
import { MessageStatus, StatusIconProps } from "../../../interfaces/all";

const IconContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "2px",
  color: "#8696a0",
  fontSize: "0.75rem",
  minWidth: "16px",
  height: "16px",
  // Garantir que seja visível
  visibility: "visible",
  opacity: 1,
});

const StatusIcon: React.FC<StatusIconProps> = ({ status }) => {
  if (!status) return null;

  // Se for uma string simples, usa ela diretamente
  if (typeof status === "string") {
    return renderStatusIcon(status as MessageStatus);
  }

  // Se for um objeto WhatsAppMessageStatus
  if ("status" in status) {
    return renderStatusIcon(status.status);
  }

  // Se for um array de statuses, pega o mais recente
  if (Array.isArray(status)) {
    const sortedStatuses = [...status].sort((a, b) => {
      const timestampA = a.timestamp ? new Date(a.timestamp).getTime() : 0;
      const timestampB = b.timestamp ? new Date(b.timestamp).getTime() : 0;
      return timestampB - timestampA; // Ordem decrescente para pegar o mais recente
    });

    const latestStatus = sortedStatuses[0]?.status;
    if (latestStatus) {
      return renderStatusIcon(latestStatus);
    }
  }

  return null;
};

const renderStatusIcon = (messageStatus: MessageStatus) => {
  switch (messageStatus) {
    case "sent":
      return (
        <IconContainer>
          <Done sx={{ fontSize: "0.875rem" }} />
        </IconContainer>
      );
    case "delivered":
      return (
        <IconContainer>
          <DoneAll sx={{ fontSize: "0.875rem" }} />
        </IconContainer>
      );
    case "read":
      return (
        <IconContainer sx={{ color: "#53bdeb" }}>
          <DoneAll sx={{ fontSize: "0.875rem" }} />
        </IconContainer>
      );
    case "failed":
      return (
        <IconContainer sx={{ color: "#f15c6d" }}>
          <Error sx={{ fontSize: "0.875rem" }} />
        </IconContainer>
      );
    default:
      return null;
  }
};

export default StatusIcon;
